"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariantType = void 0;
const react_1 = __importDefault(require("react"));
const useInExperiment_1 = require("../../../hooks/useInExperiment");
const isServer_1 = __importDefault(require("../../../utils/isServer"));
const __1 = __importDefault(require(".."));
var VariantType;
(function (VariantType) {
    VariantType["Variant"] = "variant";
    VariantType["Base"] = "base";
})(VariantType = exports.VariantType || (exports.VariantType = {}));
const getStaticExperiments = (isInAllExperiments) => Object.values(useInExperiment_1.RunningExperiments).reduce((runningExperiments, curr) => {
    const { id, isLive } = curr;
    if (!isLive) {
        return runningExperiments;
    }
    // eslint-disable-next-line no-param-reassign
    runningExperiments[id] = isInAllExperiments;
    return runningExperiments;
}, {});
const getCookiesExperiments = (cookies) => Object.values(useInExperiment_1.RunningExperiments).reduce((runningExperiments, curr) => {
    const { id, isLive } = curr;
    if (!isLive) {
        return runningExperiments;
    }
    const experimentCookie = cookies[id];
    if (!experimentCookie) {
        return runningExperiments;
    }
    // eslint-disable-next-line no-param-reassign
    runningExperiments[id] = Boolean(Number(experimentCookie));
    return runningExperiments;
}, {});
const ExperimentsContextProvider = ({ children, staticVariantType, cookies, }) => {
    const staticExperiments = staticVariantType && isServer_1.default
        ? getStaticExperiments(staticVariantType === VariantType.Variant)
        : {};
    const cookiesExperiments = getCookiesExperiments(cookies);
    // for client-side navigation, cookies experiments should overwrite static ones.
    return (react_1.default.createElement(__1.default.Provider, { value: Object.assign(Object.assign({}, staticExperiments), cookiesExperiments) }, children));
};
exports.default = ExperimentsContextProvider;
//# sourceMappingURL=ExperimentsContextProvider.js.map